import "@/App.css";
import { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { ClientLogos } from "@/components/ClientLogos";
import { Services } from "@/components/Services";
import { Stats } from "@/components/Stats";
import { FeaturedProject } from "@/components/FeaturedProject";
import { WhyChoose } from "@/components/WhyChoose";
import { Equipment } from "@/components/Equipment";
import { Deliverables } from "@/components/Deliverables";
import { Portfolio } from "@/components/Portfolio";
import { SeoContent } from "@/components/SeoContent";
import { Faq } from "@/components/Faq";
import { CtaBanner } from "@/components/CtaBanner";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { FloatingButtons } from "@/components/FloatingButtons";
import ServicePage from "@/pages/ServicePage";
import IndustryPage from "@/pages/IndustryPage";
import { useSeo } from "@/hooks/useSeo";

const SITE = process.env.REACT_APP_SITE_URL || window.location.origin;
const LOGO =
  "https://customer-assets.emergentagent.com/job_drone-survey-pro-4/artifacts/tzmknqwz_Snesar-Logo-1000%20%281%29.png";

const LandingPage = () => {
  const location = useLocation();

  useSeo({
    title:
      "SNESAR DRONES | Drone Survey & Aerial Photography",
    description:
      "Drone surveys, real estate aerial photography, mapping and construction monitoring across Maharashtra. Based in Navi Mumbai. Get a project quote.",
    keywords:
      "Drone Survey India, Drone Survey Services, Drone Survey Company, Drone Mapping Services, UAV Survey Services, Aerial Survey Company, Drone Land Survey, Drone LiDAR Survey India, Digital Elevation Model, Drone Photogrammetry, Orthomosaic Mapping, Construction Progress Monitoring, Drone Inspection Services, Powerline Inspection, Thermal Drone Inspection, Railway Drone Survey, Airport Drone Survey, Real Estate Drone Photography, Aerial Videography, GIS Mapping Services, Drone Survey Mumbai, Drone Survey Navi Mumbai, Drone Survey Pune, Drone Survey Maharashtra",
    canonical: `${SITE}/`,
    image: LOGO,
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      name: "Snesar Aerial Intelligence Pvt Ltd",
      image: LOGO,
      description:
        "Professional drone survey company offering drone land survey, LiDAR survey, photogrammetry, construction progress monitoring, powerline and thermal inspection, aerial photography and 360 virtual tours across India.",
      url: `${SITE}/`,
      telephone: "+91-7715972997",
      foundingDate: "2018",
      areaServed: ["Mumbai", "Navi Mumbai", "Pune", "Thane", "Maharashtra", "India"],
      address: {
        "@type": "PostalAddress",
        addressLocality: "Navi Mumbai",
        addressRegion: "Maharashtra",
        addressCountry: "IN",
      },
    },
  });

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-white antialiased">
      <Navbar />
      <main>
        <Hero />
        <ClientLogos />
        <Stats />
        <Services />
        <FeaturedProject />
        <WhyChoose />
        <Equipment />
        <Deliverables />
        <Portfolio />
        <SeoContent />
        <Faq />
        <CtaBanner />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/services/:slug" element={<ServicePage />} />
          <Route path="/industries/:slug" element={<IndustryPage />} />
        </Routes>
        <FloatingButtons />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
